module.exports = __webpack_public_path__ + "static/media/DF23-DevBadge-Participant.a2eb1cd8.png";